// extracted by mini-css-extract-plugin
export var button = "ComponentCoverageLandingBody-module--button--9b18a";
export var copy = "ComponentCoverageLandingBody-module--copy--95ceb";
export var header = "ComponentCoverageLandingBody-module--header--e91cc";
export var section = "ComponentCoverageLandingBody-module--section--e6dc2";
export var smallCopy = "ComponentCoverageLandingBody-module--smallCopy--1da61";
export var subtitle = "ComponentCoverageLandingBody-module--subtitle--bddf1";
export var title = "ComponentCoverageLandingBody-module--title--0b6f6";
export var uspItem = "ComponentCoverageLandingBody-module--uspItem--c6f02";
export var uspList = "ComponentCoverageLandingBody-module--uspList--93cb1";